import { useQuery } from 'react-query'
import apiRoutes from '../../api/apiRoutes'
import ApiCall from '../../api/network'
import useUser from '../useUser'

const fetchJunctions = async (user) => {
  return await ApiCall.any(
    apiRoutes.GetJunctionAndArea,
    {},
    { id: user ? user.id : '' }
  )
}

export const useJunctions = () => {
  const { user } = useUser()
  return useQuery('junctions', () => fetchJunctions(user))
}
